<!-- 开发设置 --  数据迁移 -- 外部数据实体管理 -- 外部数据列 -->
<template>
  <div>
    <Table
      ref="table"
      :loadObj='{}'
      :option="{}"
      :colObj='{
        opId:"3533",
        name:"外部数据列",
        parentId:"TABLE_ID",
        parentName:"外部数据实体管理",
        parentPath:"/system/trans/outerTable",
        parentQuery:{
        },
        addForm:{
        },
        dataClass:2,
        col:[]
      }'
    >
    </Table>
  </div>
</template>

<script>
import Table from '@/components/table/dataTablecSon';
export default {
  components: {
    Table
  },
  data() {
    return {
      firstEnter:true,
    };
  },
  computed: {
  },
  methods: {
  },
  created(){
  },
  activated(){
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>

<style></style>